"use client";

import type { WeightTrainingWorkoutStyle } from "@/lib/weight-training/workout-post-payload";
import type { Participant } from "./base-session-template";
import { ActivityDisplayPreview } from "./previews";

export type WorkoutStyle = WeightTrainingWorkoutStyle;

export type WeightTrainingTemplateData = {
  style: WorkoutStyle;
  workoutName: string;
  durationMins: number;
  totalVolume: number; // weight × reps summed (kg)
};

export type WeightTrainingParticipant = Participant;

type WeightTrainingDisplayProps = {
  data: Record<string, unknown> | WeightTrainingTemplateData | null;
  participants: {
    id: string;
    displayName: string;
    avatarUrl: string | null;
    username: string | null;
  }[];
};

export function WeightTrainingDisplay({
  data,
  participants,
}: WeightTrainingDisplayProps) {
  return (
    <ActivityDisplayPreview
      activityId="weight-training"
      data={data}
      participants={participants}
    />
  );
}
